import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, Stack } from "@mui/material";
import { CalendarItemChip } from "./CalendarItemChip";
export const CalendarMobileEventsList = ({ selectedDate, items, handleOpenModal, isSponsorshipDetailsCalendarTab = false, }) => {
    if (!selectedDate)
        return null;
    const dayItems = items.filter((item) => {
        if (["leave", "event", "course"].includes(item.type)) {
            return (selectedDate >=
                new Date(item.start.getFullYear(), item.start.getMonth(), item.start.getDate()) &&
                selectedDate <=
                    new Date(item.end.getFullYear(), item.end.getMonth(), item.end.getDate()));
        }
        return item.start.toDateString() === selectedDate.toDateString();
    });
    const formatSelectedDate = () => {
        const today = new Date();
        const isToday = selectedDate.toDateString() === today.toDateString();
        if (isToday)
            return "Today";
        return selectedDate.toLocaleDateString("en-US", {
            weekday: "long",
            month: "long",
            day: "numeric",
        });
    };
    return (_jsxs(Box, { sx: { mx: 2, mb: 2, mt: 3 }, children: [_jsx(Typography, { variant: "h6", sx: {
                    mb: 3,
                    color: "#0F172A",
                    fontWeight: 600,
                    fontSize: "20px",
                    letterSpacing: "-0.025em",
                }, children: formatSelectedDate() }), dayItems.length === 0 ? (_jsxs(Box, { sx: { textAlign: "center", py: 6, px: 4 }, children: [_jsx(Typography, { variant: "body2", sx: { color: "#64748B", fontSize: "15px", fontWeight: 500 }, children: "No events scheduled" }), _jsx(Typography, { variant: "caption", sx: { color: "#94A3B8", fontSize: "13px", mt: 0.5, display: "block" }, children: "Your day is free!" })] })) : (_jsx(Stack, { spacing: 1, children: dayItems.map((item) => (_jsx(CalendarItemChip, { item: item, onClick: () => handleOpenModal && handleOpenModal(item), isSponsorshipDetailsCalendarTab: isSponsorshipDetailsCalendarTab }, item.id))) }))] }));
};
